import React from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Typography, Divider } from "@mui/material";
import QueryBox from "../../PIDSessionView/ChatPanel/QueryBox";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { createSession } from "../../../../core/repo/sessionRepo";
import { PID_URL } from "../../../../utils/routes";
import { setPidQuerySuccess } from "../../../../core/events/pidEvents";
import { ChatHistory } from "../../PIDSessionView/ChatPanel/Header";

const useStyles = makeStyles()((theme) => ({
  container: {
    borderRadius: 12,
    background: theme.palette.background.default,
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  iconButton: {
    color: theme.palette.text.primary,
  },
}));

function ChatPanel() {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { selectedDomain } = useSelector((state) => state.domain);
  const fileId = new URLSearchParams(location.search).get("fileId");
  const tabId = new URLSearchParams(location.search).get("tabId");

  const handleQuery = async (query) => {
    try {
      let queryParams = new URLSearchParams();
      queryParams.set("fileId", fileId);
      queryParams.set("tabId", tabId);
      const response = await dispatch(createSession(selectedDomain.id, "pid"));
      history.push(`${PID_URL}/${response.id}?${queryParams.toString()}`);
      dispatch(setPidQuerySuccess(query));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box className={classes.container}>
      <Box
        px={2}
        py={1}
        display="flex"
        alignItems="center"
        justifyContent="space-between">
        <Typography fontWeight={500}>Ask Questions</Typography>
        <ChatHistory />
      </Box>
      <Divider />
      <Box flex={1} overflow={"auto"} />
      <Box px={2} py={1}>
        <QueryBox handleQuery={handleQuery} />
      </Box>
    </Box>
  );
}

export default ChatPanel;
